import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { defineCustomElements } from '@scania/tegel-react';
import { ToastProvider } from '@optimization/ssi-common';
import { MsalProvider } from '@azure/msal-react';
import { Provider } from 'react-redux';
import { msalInstance, setupAuthentication } from '@/app/msal';
import { store } from '@/app/store';
import { enableMocking } from '@/mocks/setup';
import { routes } from '@/routes';
import '@/styles/style.scss';

history.scrollRestoration = 'manual';

await setupAuthentication();

await defineCustomElements();

const router = createBrowserRouter([routes]);
const rootElement = document.querySelector('#root');

if (!rootElement) {
  throw new Error('Root element not found');
}

await enableMocking();

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </Provider>
    </MsalProvider>
  </React.StrictMode>,
);
